export const trackErrorTitles = {
  anonInteractionAfterTimeout: "anonymous-interaction-after-session-timeout",
  authInteractionAfterTimeout:
    "authenticated-guest-interaction-after-session-timeout",
  sessionActive: "session",
  invalidResetPasswordSession: "passwordResetSession"
};

export const trackErrorDescriptions = {
  anonInteractionAfterTimeout:
    "Anonymous guest interaction after session timeout",
  authInteractionAfterTimeout:
    "Authenticated guest interaction after session timeout",
  sessionActive: "User session timed out.",
  invalidResetPasswordSession: "Password reset occurred."
};
